// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".verify-user .verify-user-message[data-v-4512ce22]{gap:16px 28px}@media(max-width:599px){.verify-user .verify-user-message[data-v-4512ce22]{flex-direction:column;text-align:center}}@media(max-width:599px){.verify-user .verify-user-message .v-card__title[data-v-4512ce22]{justify-content:center}}", ""]);
// Exports
module.exports = exports;
